import React from 'react'

import { SvgIconProps, Tooltip, TooltipProps } from '@material-ui/core'
import { CreateCSSProperties } from '@material-ui/core/styles/withStyles'

import { makeAppStyles } from '../../themes'

import { InfoOutlined, SvgIconComponent } from '../../icons'


type IconTooltipColorOption = (
  'secondary' | 'primary' | 'info' | 'success' | 'warning' | 'error'
)

const useStyles = makeAppStyles<{ color: IconTooltipColorOption }>( theme => ({
  tooltip: ({ color }): CreateCSSProperties => ({
    backgroundColor: theme.palette[color].dark,
    color: theme.palette.getContrastText(theme.palette[color].dark),
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 12,
    lineHeight: 1.6,
    padding: theme.spacing(1),
    boxShadow: theme.shadows['12'],
  }),
  icon: {
    fontSize: 16,
    padding: 0,
  },
}) )


export type IconTooltipProps = {
  IconComponent?: SvgIconComponent
  IconProps?: SvgIconProps
  className?: string
  color?: IconTooltipColorOption
} & Omit<TooltipProps, 'children'>


export const SecondaryIconTooltip = ({
  IconComponent = InfoOutlined,
  IconProps = {},
  color = 'secondary',
  ...props
}: IconTooltipProps): JSX.Element => {

  const classes = useStyles({ color })

  return (
    <Tooltip
      {...props}
      classes={{
        tooltip: classes.tooltip,
      }}>
      <IconComponent
        className={classes.icon}
        color='inherit'
        {...IconProps} />
    </Tooltip>
  )
}
